// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__38pvP","description":"styles_description__3FeGN","content":"styles_content__1DLQL","name":"styles_name__1udAO"};